import request from "@/utils/request";
import * as logUtil from "@/utils/logUtil";
import mainVm from '@/main'
import {isChinese, isvalidMobile, validatAlphabets} from "@/utils/validate";
import md5 from "js-md5";

const TAG = '[Api2]';

const debug = true;
const log = (...args) => {
  logUtil.t(debug, TAG, ...args)
};

const get = (url,params) => { return request({url: url, method: 'GET', params: params}) };
const post = (url,data) => { return request({url: url, method: 'POST', data: data}) };

function isHttpSuccess(status){
  return ("" + status).substr(0, 1) === "2";
}


//检查成功 和 失败，并进行弹窗
//传递上下文 vm
export function checkSuccess(res) {
  if (isHttpSuccess(res.status) === true){
    return isJsonSuccess(res)
  }else{
    log("isHttpSuccess 错误",res);
    mainVm.$message({
      type: 'warning',
      message: res.data.msg
    });

    return false

  }
}

function isJsonSuccess(res) {
  //http格式正确，但是 v2里面返回的数据是 jsonFail 失败的数据
  if(res.data.code < 0){
    mainVm.$message({
        type: 'warning',
        message: res.data.msg
      });
    return false
  }else{
    return true
  }
}


export const addTeacherEmployees = (params)=>  post('/api/web/addTeacherEmployees',params);

export const getEmployees =  (params)=>  get('/api/web/getEmployees',params);
export const delEmployeeById =  (params)=>  post('/api/web/delEmployeeById',params);
export const setEmployeeEntryDate =  (params)=>  post('/api/web/setEmployeeEntryDate',params);
export const getMonthSalaries =  (params)=>  get('/api/web/getMonthSalaries',params);
export const getTeacherMonthFinishedLessons =  (params)=>  get('/api/web/getTeacherMonthFinishedLessons',params);

export const getTeacherMonthAbsentLessons =  (params)=>  get('/api/web/getTeacherMonthAbsentLessons',params);
export const getTeacherMonthTrialLessons =  (params)=>  get('/api/web/getTeacherMonthTrialLessons',params);
export const getObjectMeta =  (params)=>  get('/api/web/getObjectMeta',params);

export const genMonthSalaryForAllEmployees = (params)=>  post('/api/web/genMonthSalaryForAllEmployees',params);
export const deleteSong = (params)=>  post('/api/web/deleteSong',params);
export const setFeeSalaryBasicSalary = (params)=>  post('/api/web/setFeeSalaryBasicSalary',params);
export const setFeeSalaryComment = (params)=>  post('/api/web/setFeeSalaryComment',params);
export const setFeeSalaryTaskReward = (params)=>  post('/api/web/setFeeSalaryTaskReward',params);
export const setFeeSalaryLeaveLoss = (params)=>  post('/api/web/setFeeSalaryLeaveLoss',params);
export const delFeeSalary = (params)=>  post('/api/web/delFeeSalary',params);

export const setFeeSalaryLateLoss = (params)=>  post('/api/web/setFeeSalaryLateLoss',params);
export const setFeeSalaryInsuranceFee = (params)=>  post('/api/web/setFeeSalaryInsuranceFee',params);
export const setFeeSalaryTaxFee = (params)=>  post('/api/web/setFeeSalaryTaxFee',params);
export const setFeeSalaryFullAttendanceLossFee = (params)=>  post('/api/web/setFeeSalaryFullAttendanceLossFee',params);
export const updateFeeSalaryTotalFen = (params)=>  post('/api/web/updateFeeSalaryTotalFen',params);
export const setFeeSalaryInsuranceWhole = (params)=>  post('/api/web/setFeeSalaryInsuranceWhole',params);
export const setFeeSalaryPayedAmount = (params)=>  post('/api/web/setFeeSalaryPayedAmount',params);
export const setSalaryRuleLesson = (params)=>  post('/api/web/setSalaryRuleLesson',params);
export const setSalaryRuleLessonAbsent = (params)=>  post('/api/web/setSalaryRuleLessonAbsent',params);
export const setSalaryRuleLessonTrial = (params)=>  post('/api/web/setSalaryRuleLessonTrial',params);
export const setSalaryEditable = (params)=>  post('/api/web/setSalaryEditable',params);
export const setAllEmployeeTeacherLessonSalary = (params)=>  post('/api/web/setAllEmployeeTeacherLessonSalary',params);
export const setEmployeeTeacherLessonSalary = (params)=>  post('/api/web/setEmployeeTeacherLessonSalary',params);


export const getSalaryRulesLesson =  (params)=>  get('/api/web/getSalaryRulesLesson',params);
export const getMonthExpenses =  (params)=>  get('/api/web/getMonthExpenses',params);
export const getExpenseCategories =  (params)=>  get('/api/web/getExpenseCategories',params);

export const addMonthExpense = (params)=>  post('/api/web/addMonthExpense',params);


export const delMonthExpense = (params)=>  post('/api/web/delMonthExpense',params);
export const delMonthIncome =  (params)=>  post('/api/web/delMonthIncome',params);

export const setFeeMonthBalanceEdit =  (params)=>  post('/api/web/setFeeMonthBalanceEdit',params);


export const getFeeMonthTable =  (params)=>  get('/api/web/getFeeMonthTable',params);


export const getMonthIncomes =  (params)=>  get('/api/web/getMonthIncomes',params);
export const addMonthIncome =  (params)=>  post('/api/web/addMonthIncome',params);

export const getIncomeCategories =  (params)=>  get('/api/web/getIncomeCategories',params);
export const setFeeMonthTableInvestment =  (params)=>  post('/api/web/setFeeMonthTableInvestment',params);
export const setFeeMonthTableNewCardIncome =  (params)=>  post('/api/web/setFeeMonthTableNewCardIncome',params);
export const setFeeMonthTableChargeCardIncome =  (params)=>  post('/api/web/setFeeMonthTableChargeCardIncome',params);
export const setFeeMonthTableOtherIncome =  (params)=>  post('/api/web/setFeeMonthTableOtherIncome',params);
export const setFeeMonthTableLastMonthBalance =  (params)=>  post('/api/web/setFeeMonthTableLastMonthBalance',params);




export const getSchoolStudents = (params)=> get( '/api/web/getSchoolStudents',params);
export const newOssLrcContentMusic = (params)=> post( '/api/web/newOssLrcContentMusic',params);


export const setScoursePay = (params)=> post( '/api/web/setScoursePay',params);

export const newPrivateCardFinance = (params)=> post( '/api/web/newPrivateCardFinance',params);
export const getPrivateCardFinance = (params)=> post( '/api/web/getPrivateCardFinance',params);
export const addPrivateCardPay = (params)=> post( '/api/web/addPrivateCardPay',params);
export const setPrivateCardNeedPay = (params)=> post( '/api/web/setPrivateCardNeedPay',params);
export const getPrivateCardPays = (params)=> get( '/api/web/getPrivateCardPays',params);

export const getSchoolTeachers = (params)=> get( '/api/web/getSchoolTeachers',params);
export const getTeacherLessonsByDate = (params)=> get( '/api/web/getTeacherLessonsByDate',params);
export const getTeacherLessonsByPage = (params)=> get( '/api/web/getTeacherLessonsByPage',params);
export const getSchoolLessonsByDate = (params)=> get( '/api/web/getSchoolLessonsByDate',params);
export const getLessonAppraisesPaged = (params)=> get( '/api/v2/getLessonAppraisesPaged',params);
export const getTeacherLessonAppraisePaged = (params)=> get( '/api/v2/getTeacherLessonAppraisePaged',params);
export const getStudentLessons = (params)=> get( '/api/web/getStudentLessons',params);
export const getScourseLessons = (params)=> get( '/api/web/getScourseLessons',params);

export const getScouresRestLess = (params)=> get( '/api/web/getScouresRestLess',params);
export const getTeacherTrialStats = (params)=> get( '/api/web/getTeacherTrialStats',params);
export const getTeacherTrialStatsBetween = (params)=> get( '/api/web/getTeacherTrialStatsBetween',params);


export const setFeeMonthTableSalaryFee = (params)=> post( '/api/web/setFeeMonthTableSalaryFee',params);
export const setFeeMonthTableInsuranceFee = (params)=> post( '/api/web/setFeeMonthTableInsuranceFee',params);
export const setFeeMonthTableOtherFee = (params)=> post( '/api/web/setFeeMonthTableOtherFee',params);
export const setFeeMonthTableDistribution = (params)=> post( '/api/web/setFeeMonthTableDistribution',params);
export const setFeeMonthEditable = (params)=> post( '/api/web/setFeeMonthEditable',params);
export const updateFeeMonthTable = (params)=> post( '/api/web/updateFeeMonthTable',params);
export const createFeeMonthTable = (params)=> post( '/api/web/createFeeMonthTable',params);
export const addCourse = (params)=> post( '/api/web/addCourse',params);
export const setPriceForCourse = (params)=> post( '/api/web/setPriceForCourse',params);
export const getAllSchoolForManager = (params)=> get( '/api/web/getAllSchoolForManager',params);
export const getTeacherCategoryList = (params)=> get( '/api/web/getTeacherCategoryList',params);
export const getPayRequest = (params)=> get( '/api/web/getPayRequest',params);
export const getOrderListForManager = (params)=> get( '/api/web/getOrderListForManager',params);
export const getMemberDetailByID = (params)=> get( '/api/web/getMemberDetailByID',params);
export const getSchoolLessons = (params)=> get( '/api/web/getSchoolLessons',params);
export const getCouponTemplatesForManager = (params)=> get( '/api/web/getCouponTemplatesForManager',params);
export const getWorkTimeWeekConfs = (params)=> get( '/api/web/getWorkTimeWeekConfs',params);


export const delWorkTimeWeekConf = (params)=> get( '/api/web/delWorkTimeWeekConf',params);
export const updateTeacherWorkTime = (params)=> get( '/api/web/updateTeacherWorkTime',params);
export const addWorkTimeWeekConf = (params)=> post( '/api/web/addWorkTimeWeekConf',params);



export const getManagerCommands = (params)=> get( '/api/web/getManagerCommands',params);
export const doManagerCommand = (params)=> post( '/api/web/doManagerCommand',params);
export const getAllSubjects = (params)=> get( '/api/web/getAllSubjects',params);
export const getRecentNewStudents = (params)=> get( '/api/web/getRecentNewStudents',params);


export const getStudentById = (params)=> get( '/api/web/getStudentById',params);
export const updateStudent = (params)=> post( '/api/web/updateStudent',params);
export const queryStudentsByMobile = (params)=> get( '/api/web/queryStudentsByMobile',params);
export const queryStudentsByAcronyms = (params)=> get( '/api/web/queryStudentsByAcronyms',params);
export const queryStudentsByName = (params)=> get( '/api/web/queryStudentsByName',params);
export const getPersonalTeachersByStudentID = (params)=> get( '/api/web/getPersonalTeachersByStudentID',params);
export const newStudentScourse = (params)=> post( '/api/web/newStudentScourse',params);


export const addPersonalTeacher = (params)=> post( '/api/web/addPersonalTeacher',params);
export const getTeacherValidScourse = (params)=> get( '/api/web/getTeacherValidScourse',params);
export const getTeacherRecentConsumeScourse = (params)=> get( '/api/web/getTeacherRecentConsumeScourse',params);
export const getScoursesWithLessonsByStudentId = (params)=> get( '/api/web/getScoursesWithLessonsByStudentId',params);
export const getScourseTeacherCategorySalaryByScourseId = (params)=> get( '/api/web/getScourseTeacherCategorySalaryByScourseId',params);
export const addScourseTeacherCategorySalary = (params)=> post( '/api/web/addScourseTeacherCategorySalary',params);
export const deleteScourseTeacherCategorySalary = (params)=> post( '/api/web/deleteScourseTeacherCategorySalary',params);
export const setAuthOffline = (params)=> post( '/api/web/setAuthOffline',params);
export const setAuthOnline = (params)=> post( '/api/web/setAuthOnline',params);
export const getOSSMusicPostObject = (params)=> get( '/api/web/getOSSMusicPostObject',params);
export const getClassTableByDateSchool = (params)=> get( '/api/web/getClassTableByDateSchool',params);



export const newDaZheCouponTemplate = (params)=> post( '/api/web/newDaZheCouponTemplate',params);
export const newManJianCouponTemplate = (params)=> post( '/api/web/newManJianCouponTemplate',params);
export const getRecentCouponTemplatesPaginate = (params)=> get( '/api/web/getRecentCouponTemplatesPaginate',params);
export const getCouponTemplateByID = (params)=> get( '/api/web/getCouponTemplateByID',params);
export const getCouponTemplates = (params)=> get( '/api/web/getCouponTemplates',params);
export const giveCouponToMember = (params)=> post( '/api/web/giveCouponToMember',params);
export const cancelMemberCoupon = (params)=> post( '/api/web/cancelMemberCoupon',params);
export const getMemberCoupons = (params)=> get( '/api/web/getMemberCoupons',params);
export const getAllCourses = (params)=> get( '/api/web/course/all',params);
export const getAllCoursesWithOffSale = (params)=> get( '/api/web/getAllCoursesWithOffSale',params);
export const getCourseTeacherCategories = (params)=> get( '/api/web/getCourseTeacherCategories',params);
export const addCourseTeacherCategory = (params)=> post( '/api/web/addCourseTeacherCategory',params);
export const setCourseOnSale = (params)=> post( '/api/web/setCourseOnSale',params);
export const setSortForCourse = (params)=> post( '/api/web/setSortForCourse',params);
export const switchSortForCourse = (params)=> post( '/api/web/switchSortForCourse',params);


export const deleteCourseTeacherCategory = (params)=> post( '/api/web/deleteCourseTeacherCategory',params);
export const deleteCourseSubject = (params)=> post( '/api/web/deleteCourseSubject',params);
export const addCourseSubject = (params)=> post( '/api/web/addCourseSubject',params);
export const getCourseSubjects = (params)=> get( '/api/web/getCourseSubjects',params);
export const getRecharges = (params)=> get( '/api/web/getRecharges',params);
export const getTeacherMonthRecharges = (params)=> get( '/api/web/getTeacherMonthRecharges',params);
export const getScouresMonth = (params)=> get( '/api/web/getScouresMonth',params);
export const getScouresByFilter = (params)=> get( '/api/web/getScouresByFilter',params);
export const getUnusedTrialCourseCards = (params)=> get( '/api/web/getUnusedTrialCourseCards',params);
export const getRechargeByID = (params)=> get( '/api/web/getRechargeByID',params);
export const getScourseById = (params)=> get( '/api/web/getScourseById',params);


export const getTeacherScouresMonth = (params)=> get( '/api/web/getTeacherScouresMonth',params);
export const setRechargeTeacherSalary = (params)=> post( '/api/web/setRechargeTeacherSalary',params);
export const setScourseTeacherSalary = (params)=> post( '/api/web/setScourseTeacherSalary',params);
export const setScourseRechargePay = (params)=> post( '/api/web/setScourseRechargePay',params);
export const newTrialCourseCardByMid = (params)=> post( '/api/web/newTrialCourseCardByMid',params);


export const newTrialCourseCardByMobile = (params)=> post( '/api/web/newTrialCourseCardByMobile',params);
export const deleteTrialCourseCard = (params)=> post( '/api/web/deleteTrialCourseCard',params);
export const getHolidayLeave = (params)=> get( '/api/web/getHolidayLeave',params);
export const getTeacherHolidayLeave = (params)=> get( '/api/web/getTeacherHolidayLeave',params);
export const cancelHolidayLeave = (params)=> post( '/api/web/cancelHolidayLeave',params);
export const getLogEvent = (params)=> get( '/api/web/getLogEvent',params);


export const getAllLogEventType = (params)=> get( '/api/web/getAllLogEventType',params);
export const getAllLogSmsType = (params)=> get( '/api/web/getAllLogSmsType',params);
export const getLogSms = (params)=> get( '/api/web/getLogSms',params);
export const getFootprintType = (params)=> get( '/api/web/getFootprintType',params);
export const getFootprints = (params)=> get( '/api/web/getFootprints',params);


export const newOssLRCMusic = (params)=> post( '/api/web/newOssLRCMusic',params);
export const getNewMusicSubFolder = (params)=> get( '/api/web/getNewMusicSubFolder',params);

export const getRecentMusics = (params)=> get( '/api/web/getRecentMusics',params);
export const getMusicsByPage = (params)=> get( '/api/web/getMusicsByPage',params);

export const queryMusicsByAcronyms = (params)=> get( '/api/web/queryMusicsByAcronyms',params);
export const getAllTeachers = (params)=> get( '/api/web/getAllTeachersForManager',params);
export const getOutJobTeachers = (params)=> get( '/api/web/getOutJobTeachers',params);
export const getTeacherById = (params)=> get( '/api/web/getTeacherById',params);


export const queryTeachersByMobile= (params)=> get('/api/web/queryTeachersByMobile',params);

export const queryTeachersByAcronyms= (params)=> get('/api/web/queryTeachersByAcronyms',params);


export const queryTeachersByName= (params)=>get('/api/web/queryTeachersByName',params);
export const getSideBarItems= (params)=>get('/api/web/getSideBarItems',params);
export const isManagerSystemRole= (params)=>get('/api/web/isManagerSystemRole',params);

export async function queryTeachersAsync(queryString) {
  if (!queryString || queryString.length < 2) {
    return
  }
  let searchResults = [];
  if (validatAlphabets(queryString) && queryString.length >= 2) {
    searchResults = await queryTeachersByAcronyms({
      'acronyms': queryString
    })
  } else if (isChinese(queryString) && queryString.length >= 2) {
    searchResults = await queryTeachersByName({
      name: queryString
    })
  } else if (isvalidMobile(queryString)) {
    searchResults = await queryTeachersByMobile({
      mobile: queryString
    })
  }
  if (!searchResults) {
    return null
  }
  return searchResults
}

export const getPersonalStudentsByTid= (params)=> get('/api/web/getPersonalStudentsByTid',params);

export const changePersonalTeacherBatch= (params)=> post('/api/web/changePersonalTeacherBatch',params);
export const addTeacherOvertime= (params)=> post('/api/web/addTeacherOvertime',params);

export const cancelTeacherOvertime= (params)=> post('/api/web/cancelTeacherOvertime',params);
export const getTeacherOvertimes= (params)=> get('/api/web/getTeacherOvertimes',params);
export const newHolidayLeave= (params)=> post('/api/web/newHolidayLeave',params);

export const changeOnlineAuth= (params)=> post('/api/web/changeOnlineAuth',params);

export const changeOfflineAuth= (params)=> post('/api/web/changeOfflineAuth',params);

export const changeTrialAuth= (params)=> post('/api/web/changeTrialAuth',params);



export const switchSortForTeacher= (params)=> post('/api/web/switchSortForTeacher',params);



export const setSortForTeacher= (params)=> post('/api/web/setSortForTeacher',params);

export const setTrialRecommendForTeacher= (params)=> post('/api/web/setTrialRecommendForTeacher',params);

export const getTeacherSalaryConfigs= (params)=> get('/api/web/getTeacherSalaryConfigs',params);

export const getTeacherSalaryMonths= (params)=> get('/api/web/getTeacherSalaryMonths',params);



export const setBaseSalary= (params)=> post('/api/web/teacher_salary_month/setBaseSalary',params);

export const setTeachSalary= (params)=> post('/api/web/teacher_salary_month/setTeachSalary',params);
export const setTeachSalaryType= (params)=> post('/api/web/teacher_salary_month/setTeachSalaryType',params);

export const setPriceOnline= (params)=> post('/api/web/teacher_salary_month/setPriceOnline',params);
export const setPriceOffline= (params)=> post('/api/web/teacher_salary_month/setPriceOffline',params);
export const setFreeTeachNum= (params)=> post('/api/web/teacher_salary_month/setFreeTeachNum',params);
export const setTrialPercent= (params)=> post('/api/web/teacher_salary_month/setTrialPercent',params);

export const setTrialSalary= (params)=> post('/api/web/teacher_salary_month/setTrialSalary',params);
export const setTaskSalary= (params)=> post('/api/web/teacher_salary_month/setTaskSalary',params);
export const setLateDeduction= (params)=> post('/api/web/teacher_salary_month/setLateDeduction',params);
export const setLeaveDeduction= (params)=> post('/api/web/teacher_salary_month/setLeaveDeduction',params);
export const setSocialInsuranceDeduction= (params)=> post('/api/web/teacher_salary_month/setSocialInsuranceDeduction',params);

export const setBaseSalaryConfig= (params)=> post('/api/web/salary_config/setTeacherBaseSalary',params);
export const setTeacherSocialInsuranceConfig= (params)=> post('/api/web/salary_config/setTeacherSocialInsurance',params);
export const setTeachSalaryTypeConfig= (params)=> post('/api/web/salary_config/setTeachSalaryType',params);
export const setTeacherPriceOnlineConfig= (params)=> post('/api/web/salary_config/setTeacherPriceOnline',params);
export const setTeacherPriceOfflineConfig= (params)=> post('/api/web/salary_config/setTeacherPriceOffline',params);
export const setTeacherFreeTeachNumConfig= (params)=> post('/api/web/salary_config/setTeacherFreeTeachNum',params);
export const getTeacherSalaryTypeDesc= (params)=> post('/api/web/salary_config/getTeacherSalaryTypeDesc',params);


export const resetTeacherLessonPrice= (params)=> post('/api/web/resetTeacherLessonPrice',params);
export const resetAllTeacherLessonPrice= (params)=> post('/api/web/resetAllTeacherLessonPrice',params);
export const getTeachersWithoutSalaryConfig= (params)=> get('/api/web/getTeachersWithoutSalaryConfig',params);
export const addNewTeacherSalaryConfig= (params)=> post('/api/web/addNewTeacherSalaryConfig',params);
export const deleteTeacherSalaryConfig= (params)=> post('/api/web/deleteTeacherSalaryConfig',params);
export const getTeachersWithoutSalaryMonth= (params)=> get('/api/web/getTeachersWithoutSalaryMonth',params);
export const addTeacherSalaryMonth= (params)=> post('/api/web/addTeacherSalaryMonth',params);
export const setSalaryMonthBill= (params)=> post('/api/web/setSalaryMonthBill',params);

export const updateAllTrialSalaryWithCurrentDynamic= (params)=> post('/api/web/updateAllTrialSalaryWithCurrentDynamic',params);

export const updateAllTeachSalaryWithCurrentDynamic= (params)=> post('/api/web/updateAllTeachSalaryWithCurrentDynamic',params);

export const setMonthConfigBySalaryConfig= (params)=> get('/api/web/setMonthConfigBySalaryConfig',params);

export const  getAllTeachersWithIDName= (params)=> get('/api/web/getAllTeachersWithIDName',params);

export const  getTeacherRoomLog= (params)=> get('/api/web/getTeacherRoomLog',params);
export const addEmployee = (params) => post('/api/v2/addEmployee', params);


export const  setTeacherOutjob= (params)=> get('/api/web/setTeacherOutjob',params);
export const  setTeacherOnjob= (params)=> get('/api/web/setTeacherOnjob',params);
export const  setTeacherFulltime= (params)=> get('/api/web/setTeacherFulltime',params);
export const  setTeacherParttime= (params)=> get('/api/web/setTeacherParttime',params);
export const  setLessonRecordBeforeDay= (params)=> get('/api/web/setLessonRecordBeforeDay',params);
export const  setTeacherAvatar= (params)=> get('/api/web/setTeacherAvatar',params);
export const  setTeacherPoster= (params)=> get('/api/web/setTeacherPoster',params);
export const  setTeacherAppointBeforeMinute= (params)=> get('/api/web/setTeacherAppointBeforeMinute',params);
export const  setTeacherMemberId= (params)=> get('/api/web/setTeacherMemberId',params);
export const  setTeacherEntryDate= (params)=> get('/api/web/setTeacherEntryDate',params);


export const  getLessonsByTimeTid= (params)=> get('/api/web/getLessonsByTimeTid',params);

export const setLessonOnline= (params)=> post('/api/web/setLessonOnline',params);

export const setLessonOffline= (params)=> post('/api/web/setLessonOffline',params);

export const  getLessonTrialsTodo= (params)=> get('/api/web/getLessonTrialsTodo',params);

export const  getLessonTrialsDone= (params)=> get('/api/web/getLessonTrialsDone',params);

export const  getTrtcRoomRecordFiles= (params)=> get('/api/web/getTrtcRoomRecordFiles',params);

export const  getTeacherCategoryItemList= (params)=> get('/api/web/getTeacherCategoryItemList',params);

export const  deleteTeacherCategoryItem= (params)=> post('/api/web/deleteTeacherCategoryItem',params);

export const  addTeacherCategoryItem= (params)=> post('/api/web/addTeacherCategoryItem',params);

export const  addTeacherCategory= (params)=> post('/api/web/addTeacherCategory',params);

export const  updateTeacherCategory= (params)=> post('/api/web/updateTeacherCategory',params);

export const  deleteTeacherCategory= (params)=> post('/api/web/deleteTeacherCategory',params);
export const  genMobileCodeFromManager= (params)=> post('/api/web/genMobileCodeFromManager',params);
export const  renameLrcBatch= (params)=> post('/api/web/renameLrcBatch',params);
export const  getInfo= (params)=> get('/api/web/getUserInfo',params);
export const  logout= (params)=> post('/user/logout',params);
export const  login= (params)=> post('/api/web/loginAdminByMobileAndPass',params);





// WEBPACK FOOTER //
// ./src/api/Apis.js